"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggablePoolOrderInfo = void 0;
const bs58_1 = __importDefault(require("bs58"));
const loggablePoolOrderInfo = (o) => {
    let prepared = {
        poolSeed: bs58_1.default.encode(o.poolSeed),
        side: ['Bid', 'Ask'][o.side],
        limitPrice: o.limitPrice,
        ratioOfPoolAssetsToTrade: `${(o.ratioOfPoolAssetsToTrade * 100 / 65536).toFixed(2)}%`,
        orderType: ['Limit', 'ImmediateOrCancel', 'PostOnly'][o.orderType],
        clientOrderId: o.clientOrderId,
        selfTradeBehavior: ["DecrementTake", "CancelProvide", "AbortTransaction"][o.selfTradeBehavior],
        market: o.market.toBase58(),
        transactionSignature: o.transactionSignature,
        transactionSlot: o.transactionSlot,
        transferredAmount: o.transferredAmount,
        settledAmount: JSON.stringify(o.settledAmount),
        openOrderAccount: o.openOrderAccount.toBase58()
    };
    return prepared;
};
exports.loggablePoolOrderInfo = loggablePoolOrderInfo;
//# sourceMappingURL=types.js.map